'use client';

import { useSyncExternalStore } from 'react';

import { BREAKPOINTS } from '@/constants/breakpoints';

const query = `(min-width: ${BREAKPOINTS.md}px)`;

let desktopMediaQuery: MediaQueryList | null = null;
const getDesktopMediaQuery = () => {
  if (!desktopMediaQuery) desktopMediaQuery = window.matchMedia(query);
  return desktopMediaQuery;
};

const subscribe = (cb: () => void) => {
  const mediaQuery = getDesktopMediaQuery();
  mediaQuery.addEventListener('change', cb);
  return () => mediaQuery.removeEventListener('change', cb);
};

const getSnapshot = () => getDesktopMediaQuery().matches;
const getServerSnapshot = () => false;

const useIsDesktop = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useIsDesktop;
